import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CorporateConfig } from '../corporate.config';
import { HelpersService } from '../helpers/helpers.service';

/** Pass untouched request through to the next request handler. */
@Injectable({
  providedIn: 'root',
})
export class HttpInterceptorService implements HttpInterceptor {

  constructor(private helper: HelpersService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // adding withCredentials, X-Requested-With causes error when sending request to the Wordpress api for Graduate Talent
    const cmcDomain = this.helper.getPageContent(CorporateConfig.getCmsDomain);
    if (!request.url.includes(cmcDomain)) {
      // Clone the request to add the new header.
      request = request.clone({
        headers: request.headers.append('X-Requested-With', 'XMLHttpRequest'),
        withCredentials: true,
      });
    }
    return next.handle(request);
  }
}
